<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader v-if="from !== 'modal'">Production Notes
        <!-- <CButton size="sm" color="info" @click="downloadNotes()">Download/Print</CButton> -->
      </CCardHeader>
      <CCardBody>
        <div :style="editable ? 'width:90%;' : 'width:100%;'" style="float:left;overflow:scroll;">
          <table style="margin-top:30px;" class="table productionNotesTable table-bordered">
            <thead>
              <tr>
                <th style="text-align:center;">Tape</th>
                <th :colspan="configureColspan(val.production_notes)"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in val.production_notes">
                <td style="padding:0;" v-for="(cols, i) in row">
                  <input style="min-width:75px;height:30px;border-radius: 0;" :disabled="!editable" type="text" class="form-control text-center" v-model="val.production_notes[index][i]" />
                </td>
                <!-- <td>
                  <CButton size="sm" style="height:25px;width:25px;text-align:center;padding:0;" color="danger" @click="removeProductionRow(val, index)">
                    <CIcon name="cil-x-circle" />
                  </CButton>
                </td> -->
              </tr>
              <tr v-if="editable">
                <td v-for="(cols, i) in val.production_notes[0]" style="text-align:center;">
                  <CButton size="sm" style="height:25px;width:25px;text-align:center;padding:0;" color="default" @click="removeProductionColumn(val, i)">
                    <CIcon name="cil-x-circle" />
                  </CButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="width:10%;float:left;text-align:center;" v-if="editable">
          <CButton size="sm" color="success" @click="addProductionColumn(val)">
            <!-- <CIcon name="cil-plus" /> -->
            Add Col
          </CButton>
          <table class="table productionNotesTable" style="margin-top: 6px;border-left: 2px solid black;">
            <tbody>
              <tr v-for="(row, index) in val.production_notes">
                <td style="padding:0;">
                  <div style="width:100%;height:30px;">
                    <CButton size="sm" style="height:25px;margin-top: 2.5px;width:25px;text-align:center;padding:0;" color="default" @click="removeProductionRow(val, index)">
                      <CIcon name="cil-x-circle" />
                    </CButton>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="width:100%;float:left;text-align: center;" v-if="editable">
          <CButton size="sm" color="success" @click="addProductionRow(val)">
            <!-- <CIcon name="cil-plus" /> -->Add Row
          </CButton>
        </div>

        <div style="width:100%;margin-top: 15px;float:left;text-align: center;" v-if="fromSummary && editable">
          <CButton size="sm" color="secondary" @click="saveNotes()">
            <!-- <CIcon name="cil-plus" /> -->Save Production Notes
          </CButton>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
var methods = {}

methods.configureColspan = function (notes) {
  var i = 0
  if (notes) {
    for (var k in notes[0]) {
      i++
    }
  }
  return i
}

methods.saveNotes = function () {
  const postData = {
    form: this.val
  }
  axios.post(this.$apiAdress + '/api/orders/changeCsrStatus?token=' + localStorage.getItem('api_token'), postData).then(response => {
    window.Swal.fire({
      type: 'success',
      title: 'Success!',
      text: 'You have saved the production notes.'
    })
  })
}

methods.addProductionColumn = function (val) {
  val.production_notes.forEach(function (row) {
    row.push('')
  })
}

methods.removeProductionColumn = function (val, i) {
  val.production_notes.forEach(function (row) {
    row.splice(i, 1)
  })
}

methods.removeProductionRow = function (val, i) {
  val.production_notes.splice(i, 1)
}

methods.addProductionRow = function (val) {
  var length = val.production_notes[0].length
  var a = []
  for (var i = 1; i<=length;i++) {
    a.push('')
  }
  val.production_notes.push(a)
}

methods.getProductionNotes = function () {
  var rows = 10
  var cols = 5
  var arr = []

  for (var i = 1;i<=rows;i++) {
    var a = []
    for (var z = 1;z<=cols;z++) {
      a.push('')
    }
    arr.push(a)
  }
  return arr
}

export default {
  // ===Component name
  name: "ProductionNotes",
  // ===Props passed to component
  props: ['val', 'editable', 'fromSummary', 'from'],
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{

      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    if (!this.val.production_notes) {
      this.val.production_notes = this.getProductionNotes()
    }
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
